import React, { useEffect, useState } from "react";
import LoginForm from "../login/loginForm";
import { useParams } from "react-router-dom";
import Footer from "../footer";
import Intro from "../intro";
import "../login.css";
import OtpForm from "./otpForm";
import EmailOtpForm from "../emailOtp/emailOtpForm";
import SignupForm from "../signUp/SignupForm";
import { useLocation, useNavigate } from "react-router-dom";
import { useOtpverifyMutation } from "../../../services/loginservices";
import SelectField from "../../../library/components/Select";
import Button from "../../../library/components/Button";
import CustomModal from "../../../library/components/Modal/modal";
import { parseJwt, removeCookie } from "../../utilities/utils";
import { ALERT_TYPE_SUCCESS, USERTYPE } from "../../../constants/constants";
import { createAlert } from "../../../features/alert/alerts";
import MembersDetails from "../login/members/memberDetails";
import { styles } from "../login/members/member";

function Otp(state) {
  let navigate = useNavigate();
  const location = useLocation();
  const [accesstoken, setAccesstoken] = useState("");
  const [show, setShow] = useState(false);
  const [roless, setRoles] = useState();
  const [verifydisable, setVerifyDisable] = useState(true);
  const [userId,setUserId] = useState()
  // const { userId } = useParams();

  const [otpverify, otp] = useOtpverifyMutation();
  const [stateValue, setstateValue] = useState({});

    useEffect(()=>{
      removeCookie('XUSRLGLK')
          if(!location?.state?.userid){
      navigate("/login",{state:{replace:true}})
      return
          }
          setUserId(location.state?.userid)
          navigate(location.pathname,{state:{replace:true}})

      },[])


  const handleChange = (key, value) => {
    setstateValue((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
  const [otpObject, setOtpObject] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
    otp5: "",
    otp6: "",
  });
  // const roleCode = location.state?.userType;
  // const app = location.state?.app

  
  
  const handlesubmit = (e, data) => {
    setVerifyDisable(true);
    e.preventDefault();
    var eciData = {
      applicationName: USERTYPE.ERONET,
      // password: "a",
      roleCode: "*",
      otp:
        otpObject.otp1 +
        otpObject.otp2 +
        otpObject.otp3 +
        otpObject.otp4 +
        otpObject.otp5 +
        otpObject.otp6,
      username: userId,
    };
    // var serviceData = {
    //   applicationName: (roleCode=="ro"||roleCode=="cs")?USERTYPE.ETPBMS:USERTYPE.SVP,
    //   // password: "a",
    //   roleCode: roleCode,
    //   otp:
    //     otpObject.otp1 +
    //     otpObject.otp2 +
    //     otpObject.otp3 +
    //     otpObject.otp4 +
    //     otpObject.otp5 +
    //     otpObject.otp6,
    //   username: userId,
    // };
   
      otpverify(eciData).unwrap()
      .then((res) => {
        createAlert({
          message: "OTP verified Sucessfully.",
          type: ALERT_TYPE_SUCCESS,
          heading: "Sucess",
        });
        navigate(`/verifylogin`, {state: {userId:userId},replace:true});
      });;
    
  };
  // useEffect(() => {
  //   if (otp.isSuccess) {
  //     let userRoles = parseJwt(otp.data?.access_token).realm_access.roles;
  //     if (otp.data?.firstTimeLogin == "Y") {
        
  //       localStorage.setItem("first_token", otp.data?.access_token);
       
  //       for (let i = 0; i < userRoles.length; i++) {
  //         if (
  //           (
  //             userRoles[i]==="nodal" ||
  //             userRoles[i]=== "unit" ||
  //             userRoles[i]=== "record" ||
  //             userRoles[i]=== "ro" ||
  //             userRoles[i]=== "cs"
  //           )
  //         )
  //         localStorage.setItem(
  //           "userrole",
  //           userRoles[i]
  //         );
  //       }
  //       navigate("/requestotp", { state: { userId, roleCode } });
  //       // , { state: { show: true, number: data } }
  //     } 
      
  //     else if (otp.data?.firstTimeLogin == "M") {
  //       localStorage.setItem("firstLogin","M" );
  //       localStorage.setItem("first_token", otp.data?.access_token);
  //       localStorage.setItem(
  //         "first_role",
  //         parseJwt(otp.data?.access_token).realm_access.roles[0]
  //       );
  //       navigate("/requestotp");
  //       // , { state: { show: true, number: data } }
  //     } 
  //     else {
  //       localStorage.setItem("access_token", otp.data?.access_token);
  //       localStorage.setItem("refreshToken", otp.data?.refresh_token);
  //       localStorage.setItem("expiry", otp.data?.expires_in);
  //       localStorage.setItem("refreshExpiry", otp.data?.refresh_expires_in);
  //       localStorage.setItem(
  //         "userrole",
  //         parseJwt(otp.data?.access_token).realm_access.roles[0]
  //       );
  //       localStorage.setItem(
  //         "roles",
  //         parseJwt(otp.data?.access_token).realm_access.roles
  //       );
  //       var roles = [{ value: "", label: "Select Role" }];
  //       var role = userRoles;
  //       for (let i = 0; i < userRoles.length; i++) {
  //         if (
  //           !(
  //             role[i].includes("default") ||
  //             role[i].includes("offline") ||
  //             role[i].includes("admn") ||
  //             role[i].includes("authorization")
  //           )
  //         )
  //           roles.push({ value: role[i], label: role[i] });
  //       }
  //       setRoles(roles);

  //       if (roles.length > 2) {
  //         setShow(true);
  //         // window.location.href = "/" + stateValue.role
  //       } else {
  //         var elseroles = [];
  //         for (let i = 0; i < userRoles.length; i++) {
  //           if (
  //             !(
  //               role[i].includes("default") ||
  //               role[i].includes("offline") ||
  //               role[i].includes("admn") ||
  //               role[i].includes("authorization")
  //             )
  //           )
  //             elseroles.push(role[i]);
  //         }
  //         localStorage.userrole = elseroles[0];
  //         window.location.href = "/" + elseroles[0]+"/"+"dashboard";
  //       }
  //     }
  //   }
  // }, [otp.isSuccess]);


  return (
  <div style={styles.main}>
        <div style={styles.row}>

          {/* Left Div - Commissioners */}
          <MembersDetails></MembersDetails>
            <div style={styles.boxLogin}>
          <div className="form_login">
            <form onSubmit={handlesubmit} className="form_align">
              <OtpForm
                otpObject={otpObject}
                setOtpObject={setOtpObject}
                // data={roleCode}
                userId={userId}
                setVerifyDisable={setVerifyDisable}
                verifydisable={verifydisable}

              ></OtpForm>

              {/* <EmailOtpForm
                otpObject={otpObject}
                setOtpObject={setOtpObject}
                data={data}
              ></EmailOtpForm> */}
            </form>
          </div>
      </div>
      <CustomModal
        modalTitle=""
        children={
          <div className="pl-3 pt-2">
            <SelectField
              label="Select Role"
              required={true}
              name="role"
              options={roless}
              // options={dropdownvaluefilter(formtypefilter,"value")}
              labelClass="col-md-12 pr-0 pt-2 processing-label"
              inputClass="col-md-12"
              value={stateValue.role}
              handleChange={(val) => handleChange("role", val)}
            />
          </div>
        }
        show={show}
        size="30%"
        modalFooter={
          <Button
            btnClass="px-4 btn-blue mb-4 float-right"
            value={<>Submit &nbsp;</>}
            type="submit"
            onClick={() => {
              setShow(false);
              localStorage.userrole = stateValue.role;
              window.location.href = "/" + stateValue.role+"/"+"dashboard";
            }}
          />
        }
      />
    </div>
    </div>
  );
}

export default Otp;
